import type { PointerButtonFlags } from './types/pointer-button-flags'

/** Primary button + Ctrl/Cmd+Shift (no Alt): marquee zoom drag. */
export function isMarqueeZoomPointerStart(e: PointerButtonFlags): boolean {
  return e.button === 0 && (e.ctrlKey || e.metaKey) && e.shiftKey && !e.altKey
}

/** Middle button: drag-pan without toggling hand tool. */
export function isMiddleButtonPanPointerStart(e: Pick<PointerEvent, 'button'>): boolean {
  return e.button === 1
}
